import { render, staticRenderFns } from "./PoTable.vue?vue&type=template&id=77b5531a"
import script from "./PoTable.vue?vue&type=script&lang=ts"
export * from "./PoTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports